<template>
  <v-container
    class="wrapper white--text"
    @mouseleave="hover = false"
    @mouseover="hover = true"
  >
    <v-img
      :src="image"
      class="image rounded-image"
      :style="{
        height: height ? height : '',
        width: width ? width : '',
      }"
    >
      <v-flex class="content" align-end d-flex fill-height>
        <div class="footer justify-center align-center d-flex">
          <slot name="title" />
        </div>

        <div
          :class="{
            'd-flex':
              ($vuetify.breakpoint.mdAndUp && hover) ||
              $vuetify.breakpoint.smAndDown,
          }"
          class="overlay justify-center align-center d-none"
        >
          <v-row content="center" justify="center">
            <v-col v-if="showTitle" cols="12">
              <slot name="title" />
            </v-col>
            <v-col v-if="showDescription" class="description" cols="12">
              <slot name="description" />
            </v-col>
            <v-col cols="12" align="center">
              <slot name="button" />
            </v-col>
          </v-row>
        </div>
      </v-flex>
    </v-img>
  </v-container>
</template>

<script>
export default {
  name: 'Goal',
  props: {
    image: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      required: false,
      default: null,
    },
    width: {
      type: String,
      required: false,
      default: null,
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: true,
    },
    showDescription: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      hover: false,
    };
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.wrapper
  font-family: "Cera pro", serif
  font-size: 1.1em

  .image
    overflow: hidden
    border-radius: 15px

    .content

      .footer
        background-color: #01ee55
        height: 20%
        width: 100%
        color: #fff
        transition: opacity .5s

      .overlay
        position: absolute
        width: 100%
        height: 100%
        color: #fff
        background-color: rgba(1, 238, 85, 0.7)
        transition: opacity .5s
        opacity: 0

      &:hover
        .footer
          opacity: 0

        .overlay
          opacity: 1

      @media screen and (max-width: $md)
        .footer
          opacity: 0 !important

        .overlay
          opacity: 1 !important
.new-color
  .wrapper
    font-family: "metropolisregular", serif
    .image
      .content
        .footer
          background-color: #26d07c
        .overlay
          background-color: rgba(38, 208, 124, 0.7)
</style>
